<template>
  <v-card height="300" class="pa-8 d-flex flex-column  align-center">
    <div class="d-flex flex-column align-center">
      <v-icon size="80" color="yellow darken-1">mdi-alert</v-icon>
      <h1 class="py-2">{{ $t("alert.warning") }}</h1>
    </div>
    <div class="flex-grow-1">
      <h1 class="py-2 body-1">{{ $t("alert.close_assignment_question") }}</h1>
    </div>
    <div>
      <CommonButton
        @handleClick="
          toggleCloseAssignmentDialog({
            isCloseAssignmentDialogOpened: false
          })
        "
        color="transparent"
        :label="$t('common.cancel')"
        width="100"
        customClassName="secondary--text font-weight-medium"
      />
      <CommonButton
        color="primary"
        :label="$t('common.yes')"
        width="100"
        customClassName="ml-2"
        @handleClick="handleDeleteAssignment"
      />
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "@/store/ModuleTypes";
import { AssignmentActionTypes } from "../enums/AssignmentActionTypes";
import CommonButton from "../common/CommonButton";

export default {
  name: "CloseAssignmentModal",
  components: { CommonButton },

  computed: {
    ...mapGetters(ModuleTypes.ASSIGNMENTS, [
      "isCloseAssignmentDialogOpened",
      "assignmentItemDetails"
    ])
  },
  methods: {
    ...mapMutations(ModuleTypes.ASSIGNMENTS, ["toggleCloseAssignmentDialog"]),
    ...mapActions(ModuleTypes.ASSIGNMENTS, ["closeOrDeleteAssignment"]),

    handleDeleteAssignment() {
      this.closeOrDeleteAssignment({
        organizationId: this.$route.params?.organizationId,
        assignmentId: this.assignmentItemDetails?.assignmentId,
        actionType: AssignmentActionTypes.CLOSE
      });
      this.toggleCloseAssignmentDialog({
        isDeleteAssignmentDialogOpened: false
      });
    }
  }
};
</script>

<style scoped></style>
